// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/arrow-down-large.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/arrow-right-large.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/images/arrow-left-large.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.industries_banner {
  border-top: 12px solid #00305b;
  background-repeat: no-repeat !important;
  background-size: cover !important;
}
.industries_banner:after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  width: 50%;
  background-color: rgb(255 255 254 / 55%);
}
@media screen and (min-width: 576px) {
  .industries_banner.text_right:after {
    left: 50%;
  }
}
.text_right .row {
  justify-content: flex-end;
}

.ib_content {
  padding: 6rem 4rem 6rem 0;
  z-index: 1;
}
.text_right .ib_content {
  padding: 6rem 4rem;
}

.ib_content > h2 {
  font-size: 3.8rem;
  color: #00305b;
  line-height: 0.9;
  font-weight: 500;
  margin-bottom: 1.5rem;
}
.ib_content > p {
  color: #474747;
  font-size: 1.313rem;
  font-style: italic;
  line-height: 1.8;
  font-weight: 500;
}
.btn.btn-style-two {
  border-radius: 0;
  box-shadow: 0 1px 4px rgb(0 0 0 / 44%), 0 1px 4px rgb(0 0 0 / 43%);
  transition: border-color 0.4s ease 0s, background-color 0.4s ease 0s;
  background-color: #00305b;
  color: #fff;
  padding: 0.8rem 2rem;
}
.btn.btn-style-two:hover {
  background-color: #b0aaa9;
  color: #2f2e2e;
}
.btn.btn-style-three {
  border-radius: 0;
  box-shadow: 0 1px 4px rgb(0 0 0 / 35%), 0 1px 4px rgb(0 0 0 / 35%);
  transition: color 0.4s ease 0s;
  background-color: #b0aaa9;
  color: #fff;
  padding: 0.8rem 1rem;
}
.btn.btn-style-three:hover,
.btn.btn-style-three:active,
.btn.btn-style-three:focus {
  color: #2f2e2e;
  background-color: #b0aaa9;
}

.incentives {
  background-position: center !important;
  background-repeat: no-repeat !important;
  background-size: cover !important;
  position: relative;
  padding: 4rem 0;
}

.incentive_text {
  background-color: rgb(47 46 46 / 40%);
  padding: 1rem;
}
.incentive_text > p {
  font-size: 2.5rem;
  font-weight: 200;
  line-height: 1.2;
}

.sec_style_one {
  background-color: #354a59;
  padding: 2rem 0;
}
.sso_heading > h2 {
  font-size: 4rem;
  line-height: 0.9;
  padding: 0 6rem;
  position: relative;
  margin-bottom: 1.5rem;
}
.sso_heading > h2:before,
.sso_heading > h2:after {
  content: "";
  position: absolute;
  top: 0;
  width: 5rem;
  height: 5rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center center
    no-repeat;
  background-size: contain;
}
.sso_heading > h2:before {
  left: 0;
}
.sso_heading > h2:after {
  right: 0;
}
.sso_listing ul li {
  color: #b0aaa9;
  font-size: 1.313rem;
  font-style: italic;
  font-weight: 500;
  line-height: 1.8;
}

.sec_style_two {
  background-color: #6e6968;
  padding: 2rem 0;
}
.sst_heading > h2 {
  font-size: 4rem;
  line-height: 0.9;
  padding: 0 6rem;
  position: relative;
  margin-bottom: 1.5rem;
}
.sst_heading > h2:before,
.sst_heading > h2:after {
  content: "";
  position: absolute;
  top: 0;
  width: 5rem;
  height: 5rem;
  background-size: contain !important;
}
.sst_heading > h2:before {
  left: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) center center
    no-repeat;
}
.sst_heading > h2:after {
  right: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) center center
    no-repeat;
  background-size: contain;
}
.sst_listing > p {
  font-size: 1.313rem;
  font-style: italic;
}
.sst_listing ul li {
  font-size: 1.063rem;
  font-weight: 600;
}

.sec_alt {
  background-color: #00305b;
  padding: 3rem 0;
}
.sec_alt_txt {
  padding: 0 2rem;
}
.sec_alt_txt h2 {
  font-size: 3.75rem;
  text-align: center;
  line-height: 0.9;
}

.tes_grid {
  padding: 3rem 0;
}
.tes_grid_item {
  padding: 1.5rem;
}

@media screen and (max-width: 1024px) {
  .text_right .ib_content {
    padding: 3rem 1rem 3rem 3rem;
  }
  .ib_content {
    padding: 3rem 3rem 3rem 0;
  }
  .ib_content > h2,
  .sso_heading > h2,
  .sst_heading > h2,
  .sec_alt_txt h2 {
    font-size: 3rem;
  }
  .sso_heading > h2:before,
  .sso_heading > h2:after,
  .sst_heading > h2:before,
  .sst_heading > h2:after {
    width: 3rem;
    height: 3rem;
  }
  .sst_heading > h2,
  .sso_heading > h2 {
    padding: 0 3rem;
  }
}
@media screen and (max-width: 767px) {
  .text_right .ib_content {
    padding: 2rem 1rem 2rem 2rem;
  }
  .ib_content > h2,
  .sso_heading > h2,
  .sst_heading > h2,
  .sec_alt_txt h2,
  .incentive_text > p {
    font-size: 2rem;
  }
  .ib_content > p,
  .sso_listing ul li,
  .sst_listing > p,
  .sst_listing ul li {
    font-size: 1rem;
    line-height: 1.4;
  }
  .btn.btn-style-two {
    padding: 0.6rem 1rem;
  }
  .sec_alt_txt {
    padding: 2rem 0 0;
  }
}
@media screen and (max-width: 575px) {
  .industries_banner:after {
    width: 100%;
  }
  .text_right .ib_content,
  .ib_content {
    padding: 2rem;
  }
  .sso_heading > h2:before,
  .sso_heading > h2:after,
  .sst_heading > h2:before,
  .sst_heading > h2:after {
    width: 2rem;
    height: 2rem;
  }
  .sst_heading > h2,
  .sso_heading > h2 {
    padding: 0 2rem;
  }
  .ib_content > h2,
  .sso_heading > h2,
  .sst_heading > h2,
  .sec_alt_txt h2,
  .incentive_text > p {
    font-size: 1.4rem;
  }
  .incentives {
    padding: 0rem 0;
  }
  .industries_banner {
    border-top: 6px solid #00305b;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/real-estate/realestate.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,uCAAuC;EACvC,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,wCAAwC;AAC1C;AACA;EACE;IACE,SAAS;EACX;AACF;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,kEAAkE;EAClE,oEAAoE;EACpE,yBAAyB;EACzB,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,kEAAkE;EAClE,8BAA8B;EAC9B,yBAAyB;EACzB,WAAW;EACX,oBAAoB;AACtB;AACA;;;EAGE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,uCAAuC;EACvC,iCAAiC;EACjC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;AACvB;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,YAAY;EACZ;aACW;EACX,wBAAwB;AAC1B;AACA;EACE,OAAO;AACT;AACA;EACE,QAAQ;AACV;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;AACvB;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,YAAY;EACZ,mCAAmC;AACrC;AACA;EACE,OAAO;EACP;aACW;AACb;AACA;EACE,QAAQ;EACR;aACW;EACX,wBAAwB;AAC1B;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,yBAAyB;EAC3B;EACA;;;;IAIE,eAAe;EACjB;EACA;;;;IAIE,WAAW;IACX,YAAY;EACd;EACA;;IAEE,eAAe;EACjB;AACF;AACA;EACE;IACE,4BAA4B;EAC9B;EACA;;;;;IAKE,eAAe;EACjB;EACA;;;;IAIE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,WAAW;EACb;EACA;;IAEE,aAAa;EACf;EACA;;;;IAIE,WAAW;IACX,YAAY;EACd;EACA;;IAEE,eAAe;EACjB;EACA;;;;;IAKE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,6BAA6B;EAC/B;AACF","sourcesContent":[".industries_banner {\n  border-top: 12px solid #00305b;\n  background-repeat: no-repeat !important;\n  background-size: cover !important;\n}\n.industries_banner:after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 50%;\n  background-color: rgb(255 255 254 / 55%);\n}\n@media screen and (min-width: 576px) {\n  .industries_banner.text_right:after {\n    left: 50%;\n  }\n}\n.text_right .row {\n  justify-content: flex-end;\n}\n\n.ib_content {\n  padding: 6rem 4rem 6rem 0;\n  z-index: 1;\n}\n.text_right .ib_content {\n  padding: 6rem 4rem;\n}\n\n.ib_content > h2 {\n  font-size: 3.8rem;\n  color: #00305b;\n  line-height: 0.9;\n  font-weight: 500;\n  margin-bottom: 1.5rem;\n}\n.ib_content > p {\n  color: #474747;\n  font-size: 1.313rem;\n  font-style: italic;\n  line-height: 1.8;\n  font-weight: 500;\n}\n.btn.btn-style-two {\n  border-radius: 0;\n  box-shadow: 0 1px 4px rgb(0 0 0 / 44%), 0 1px 4px rgb(0 0 0 / 43%);\n  transition: border-color 0.4s ease 0s, background-color 0.4s ease 0s;\n  background-color: #00305b;\n  color: #fff;\n  padding: 0.8rem 2rem;\n}\n.btn.btn-style-two:hover {\n  background-color: #b0aaa9;\n  color: #2f2e2e;\n}\n.btn.btn-style-three {\n  border-radius: 0;\n  box-shadow: 0 1px 4px rgb(0 0 0 / 35%), 0 1px 4px rgb(0 0 0 / 35%);\n  transition: color 0.4s ease 0s;\n  background-color: #b0aaa9;\n  color: #fff;\n  padding: 0.8rem 1rem;\n}\n.btn.btn-style-three:hover,\n.btn.btn-style-three:active,\n.btn.btn-style-three:focus {\n  color: #2f2e2e;\n  background-color: #b0aaa9;\n}\n\n.incentives {\n  background-position: center !important;\n  background-repeat: no-repeat !important;\n  background-size: cover !important;\n  position: relative;\n  padding: 4rem 0;\n}\n\n.incentive_text {\n  background-color: rgb(47 46 46 / 40%);\n  padding: 1rem;\n}\n.incentive_text > p {\n  font-size: 2.5rem;\n  font-weight: 200;\n  line-height: 1.2;\n}\n\n.sec_style_one {\n  background-color: #354a59;\n  padding: 2rem 0;\n}\n.sso_heading > h2 {\n  font-size: 4rem;\n  line-height: 0.9;\n  padding: 0 6rem;\n  position: relative;\n  margin-bottom: 1.5rem;\n}\n.sso_heading > h2:before,\n.sso_heading > h2:after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  width: 5rem;\n  height: 5rem;\n  background: url(../../assets/images/arrow-down-large.svg) center center\n    no-repeat;\n  background-size: contain;\n}\n.sso_heading > h2:before {\n  left: 0;\n}\n.sso_heading > h2:after {\n  right: 0;\n}\n.sso_listing ul li {\n  color: #b0aaa9;\n  font-size: 1.313rem;\n  font-style: italic;\n  font-weight: 500;\n  line-height: 1.8;\n}\n\n.sec_style_two {\n  background-color: #6e6968;\n  padding: 2rem 0;\n}\n.sst_heading > h2 {\n  font-size: 4rem;\n  line-height: 0.9;\n  padding: 0 6rem;\n  position: relative;\n  margin-bottom: 1.5rem;\n}\n.sst_heading > h2:before,\n.sst_heading > h2:after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  width: 5rem;\n  height: 5rem;\n  background-size: contain !important;\n}\n.sst_heading > h2:before {\n  left: 0;\n  background: url(../../assets/images/arrow-right-large.svg) center center\n    no-repeat;\n}\n.sst_heading > h2:after {\n  right: 0;\n  background: url(../../assets/images/arrow-left-large.svg) center center\n    no-repeat;\n  background-size: contain;\n}\n.sst_listing > p {\n  font-size: 1.313rem;\n  font-style: italic;\n}\n.sst_listing ul li {\n  font-size: 1.063rem;\n  font-weight: 600;\n}\n\n.sec_alt {\n  background-color: #00305b;\n  padding: 3rem 0;\n}\n.sec_alt_txt {\n  padding: 0 2rem;\n}\n.sec_alt_txt h2 {\n  font-size: 3.75rem;\n  text-align: center;\n  line-height: 0.9;\n}\n\n.tes_grid {\n  padding: 3rem 0;\n}\n.tes_grid_item {\n  padding: 1.5rem;\n}\n\n@media screen and (max-width: 1024px) {\n  .text_right .ib_content {\n    padding: 3rem 1rem 3rem 3rem;\n  }\n  .ib_content {\n    padding: 3rem 3rem 3rem 0;\n  }\n  .ib_content > h2,\n  .sso_heading > h2,\n  .sst_heading > h2,\n  .sec_alt_txt h2 {\n    font-size: 3rem;\n  }\n  .sso_heading > h2:before,\n  .sso_heading > h2:after,\n  .sst_heading > h2:before,\n  .sst_heading > h2:after {\n    width: 3rem;\n    height: 3rem;\n  }\n  .sst_heading > h2,\n  .sso_heading > h2 {\n    padding: 0 3rem;\n  }\n}\n@media screen and (max-width: 767px) {\n  .text_right .ib_content {\n    padding: 2rem 1rem 2rem 2rem;\n  }\n  .ib_content > h2,\n  .sso_heading > h2,\n  .sst_heading > h2,\n  .sec_alt_txt h2,\n  .incentive_text > p {\n    font-size: 2rem;\n  }\n  .ib_content > p,\n  .sso_listing ul li,\n  .sst_listing > p,\n  .sst_listing ul li {\n    font-size: 1rem;\n    line-height: 1.4;\n  }\n  .btn.btn-style-two {\n    padding: 0.6rem 1rem;\n  }\n  .sec_alt_txt {\n    padding: 2rem 0 0;\n  }\n}\n@media screen and (max-width: 575px) {\n  .industries_banner:after {\n    width: 100%;\n  }\n  .text_right .ib_content,\n  .ib_content {\n    padding: 2rem;\n  }\n  .sso_heading > h2:before,\n  .sso_heading > h2:after,\n  .sst_heading > h2:before,\n  .sst_heading > h2:after {\n    width: 2rem;\n    height: 2rem;\n  }\n  .sst_heading > h2,\n  .sso_heading > h2 {\n    padding: 0 2rem;\n  }\n  .ib_content > h2,\n  .sso_heading > h2,\n  .sst_heading > h2,\n  .sec_alt_txt h2,\n  .incentive_text > p {\n    font-size: 1.4rem;\n  }\n  .incentives {\n    padding: 0rem 0;\n  }\n  .industries_banner {\n    border-top: 6px solid #00305b;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
